import { render } from "./cashTransfer.vue?vue&type=template&id=6509f92a&scoped=true"
import script from "./cashTransfer.vue?vue&type=script&lang=js"
export * from "./cashTransfer.vue?vue&type=script&lang=js"

import "./cashTransfer.vue?vue&type=style&index=0&id=6509f92a&scoped=true&lang=css"
import "./cashTransfer.vue?vue&type=style&index=1&id=6509f92a&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6509f92a"]])

export default __exports__